export class DSLErrorCollector {
    public errors: Array<{ line: number; column: number; msg: string }> = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public syntaxError(recognizer: any, offendingSymbol: any, line: any, column: any, msg: any, e: any): void {
        this.errors.push({ line, column, msg });
    }

    public reportAmbiguity(): void {
        // do nothing
    }

    public reportAttemptingFullContext(): void {
        // do nothing
    }

    public reportContextSensitivity(): void {
        // do nothing
    }
}
